import { Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { OnScreenMessagingService } from '@pattern-library/onscreen-messaging/onscreen-messaging.service';
import { AuthLayoutComponent } from '../layout/auth-layout.component';
import { InputComponent } from '@design-system/forms/input/input.component';
import { ButtonComponent } from '@design-system/buttons/button/button.component';
import { H3Component } from '@design-system/typography/h3/h3.component';
import { CommonModule } from '@angular/common';
import { ForgotPasswordStateService } from './state/forgot-password.state-service';
import { PComponent } from '@design-system/layout/p/p.component';
import { TestIdDirective } from '@design-system/core/test-id.directive';

@Component({
  selector: 'app-forgot-password-form',
  templateUrl: './forgot-password-form.component.html',
  styleUrls: ['./forgot-password-form.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    AuthLayoutComponent,
    InputComponent,
    ButtonComponent,
    H3Component,
    PComponent,
    TestIdDirective
  ],
  providers: [
    ForgotPasswordStateService
  ]
})
export class ForgotPasswordFormComponent {
  constructor(
    public stateService: ForgotPasswordStateService, 
    private router: Router, 
    private messaging: OnScreenMessagingService
  ) {
    this.stateService.setUpForm();
  }
  
  onSubmit(): void {
    this.stateService.persist$().subscribe(() => {
      const hasValidationErrors = this.stateService.serverValidationErrors;
      if (!hasValidationErrors) {
        this.messaging.success('If your email is registered a password reset link has been sent to your email');
        this.return();
      }
    });
  }

  return(): void {
    this.router.navigate(['/auth', { outlets: { top: ['sign-in'] } }]);
  }
} 